import React from "react";
import HomeHero from "../component/HomeHero";
import DigitalCore from "../component/DigitalCore";
import DigitalSection from "../component/DigitalSection";
import Empowering from "../component/Empowering";
import HoverGrid from "../component/HoverGrid";
import Careerspage from "../component/Careerspage";
import Footer from "../component/Footer";

const Home = () => {
  return (
    <>
      <HomeHero />
      <DigitalCore />
      <DigitalSection />
      <Empowering />
      <HoverGrid />
      <Careerspage />
      <Footer />
    </>
  );
};

export default Home;

